import React, { Component } from 'react';
import { connect } from 'react-redux';
import LinkAgent from '../LinkAgent';
import FashionIcon from '../FashionIcon';

export class BarContainer extends Component {
  static defaultProps = {
    favoritesCount: 0,
    memberUuid: '',
  }

  fillBar = () => {
    let multiplier = (this.props.favoritesCount / 4) * 100;
    return [multiplier, '%'].join('')
  }

  introStep = () => {
    return(
      <div className="instructions">
        Unveil your style. Save
        <FashionIcon ariaLabel="favorited" iconCssName='filled-heart' name='heart_filled' role="img" />
        at least 4 rings
      </div>
    )
  }

  intermediateStep = () => {
    return(
      <div className="instructions">
        Keep going! Save at least 4 styles to
        <LinkAgent classes='seeRingsButton incomplete' target='_blank' disabled={true} linkText='See Ring Hints'/>
      </div>
    )
  }

  lastStep = () => {
    const { favoritesCount, memberUuid } = this.props;

    return(
      <div className="instructions">
        Your recommendations are ready!
        <LinkAgent ariaLabel={`See Ring Hints(${favoritesCount} styles)`} classes='seeRingsButton complete' target='_blank' href={"/fashion/boards/index.html#/favorites/" + memberUuid} linkText='See Ring Hints'/>
      </div>
    )
  }

  barText = () => {
    const { favoritesCount, memberUuid } = this.props;
    switch (true) {
      case favoritesCount == 0:
        return this.introStep();
        break;
      case favoritesCount < 4:
        return this.intermediateStep();
        break;

      default:
        return this.lastStep(memberUuid);
        break;
    }
  }

  render() {
    const ariaLabel = this.props.favoritesCount > 0
      ? `${this.props.favoritesCount} ring${this.props.favoritesCount > 1 ? 's' : ''} saved`
      : 'Unveil your style. Save at least 4 rings';

    return(
      <div className="cta-container" role="progressbar" aria-label={ ariaLabel }>
        { this.barText() }
        <div className="see-rings-progress" style={{width: this.fillBar()}}></div>
      </div>
    )
  }
}

export function mapStateToProps(state, ownProps) {
  let member = state.membership.member;
  let memberUuid = member ? member.id : '';
  return {
    favoritesCount: state.favoriteData.favoritesCount,
    memberUuid: memberUuid,
  };
}

// export default BarContainer;
export default connect(mapStateToProps)(BarContainer);
